export const parseStringToJson = data => {
  return typeof data === 'string' ? JSON.parse(data) : data
}
